import type { CurrencyResult, SupportedCurrency } from "./CurrencyTypes";

const BASE = "https://api.ayesearch.com/api/currency/";

async function json<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.error || `Currency API returned HTTP ${response.status}`);
  }
  return data as T;
}

export function resolveCurrencyQuery(query: string): Promise<CurrencyResult> {
  const url = new URL(`${BASE}resolve/`);
  url.searchParams.set("q", query);
  return json<CurrencyResult>(url.toString());
}

export function convertCurrency(
  amount: string | number,
  from: string,
  to: string,
): Promise<CurrencyResult> {
  const url = new URL(`${BASE}convert/`);
  url.searchParams.set("amount", String(amount));
  url.searchParams.set("from", from);
  url.searchParams.set("to", to);
  return json<CurrencyResult>(url.toString());
}

export async function supportedCurrencies(): Promise<SupportedCurrency[]> {
  const data = await json<{ items?: SupportedCurrency[] }>(`${BASE}supported/`);
  return Array.isArray(data.items) ? data.items : [];
}
